<a
  href="https://rentag.ru/auth"
  pButton
  class="p-button-secondary p-button-s font-bold"
  label="Войти"
></a>

